export default {
	"181c94ea9df20f32666476fdac3b4046": "购买了此商品"
}
